import { useState } from 'react';
import { cardLabel, type CompletedRound } from '@planning-session/shared';
import { ChevronIcon } from './ui/Icon.js';
import styles from './History.module.css';

export interface HistoryProps {
  readonly rounds: readonly CompletedRound[];
}

function headline(round: CompletedRound): string {
  if (round.summary.consensus) return cardLabel(round.summary.distribution[0]?.value ?? '—');
  return round.summary.average === null ? '—' : `~${round.summary.average}`;
}

export function History({ rounds }: HistoryProps) {
  const [expanded, setExpanded] = useState<string | null>(null);

  return (
    <div className={styles.wrap}>
      <div className={styles.list}>
        {[...rounds].reverse().map((round) => {
          const isOpen = expanded === round.id;
          return (
            <div key={round.id} className={styles.item}>
              <button
                type="button"
                className={styles.summaryRow}
                aria-expanded={isOpen}
                onClick={() => setExpanded(isOpen ? null : round.id)}
              >
                <span
                  className={`${styles.dot} ${round.summary.consensus ? styles.dotAgreed : styles.dotSplit}`}
                  aria-hidden="true"
                />
                <span className={`${styles.title} ${round.title ? '' : styles.untitled}`}>
                  {round.title || 'Untitled story'}
                </span>
                <span className={styles.value}>{headline(round)}</span>
                <span className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}>
                  <ChevronIcon size={14} />
                </span>
              </button>

              {isOpen && (
                <div className={styles.votes}>
                  {Object.entries(round.votes).map(([participantId, value]) => (
                    <span key={participantId} className={styles.vote}>
                      <span className={styles.voter}>{round.participantNames[participantId] ?? 'Someone'}</span>
                      <span className={styles.voteCard}>{cardLabel(value)}</span>
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
